import isWorker from "../../utils/isWorker";
import apiPlatform from "../../apiPlatform";

export const SET = 'ScreenBackground/SET';
export const UPDATE_EDITING = 'ScreenBackground/UPDATE_EDITING';
export const UPDATE_MODAL_OPEN = 'ScreenBackground/UPDATE_MODAL_OPEN';

export function setScreenBackground(screenBackground) {
  return {
    type: SET,
    screenBackground,
  }
}
export function enableEditing() {
  return {
    type: UPDATE_EDITING,
    _editing: true,
  }
}
export function disableEditing() {
  return {
    type: UPDATE_EDITING,
    _editing: false,
  }
}

export function setModalOpen(modalOpen) {
  return {
    type: UPDATE_MODAL_OPEN,
    _modalOpen: modalOpen,
  }
}

export function updateScreenBackground(screenBackground) {
  return dispatch => {
    dispatch(setScreenBackground(screenBackground))
    const saveFn = isWorker() ? apiPlatform.worker.updateScreenBackground : apiPlatform.users.updateScreenBackground
    saveFn(screenBackground)
  }
}